export const CASES_UNREAD_BADGE_COUNT = 100;
export const MAX_STATUS_TITLE_CHARACTER = 50;
